import React from 'react';
import { 
  HelpCircle, 
  Briefcase, 
  Clock, 
  TrendingUp, 
  DollarSign, 
  Shield, 
  BarChart2, 
  Percent 
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами по инвестированию
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Briefcase,
      title: 'Диверсификация',
      description: 'Распределяйте активы между разными классами и секторами для снижения рисков.'
    },
    {
      icon: Clock,
      title: 'Долгосрочный горизонт',
      description: 'Инвестируйте на длительный срок, чтобы сгладить рыночные колебания и использовать силу сложного процента.'
    },
    {
      icon: TrendingUp,
      title: 'Регулярность',
      description: 'Делайте регулярные взносы вне зависимости от состояния рынка, используя стратегию усреднения.'
    },
    {
      icon: DollarSign,
      title: 'Налоговая эффективность',
      description: 'Используйте ИИС для получения налогового вычета или освобождения от НДФЛ.'
    },
    {
      icon: Shield,
      title: 'Защита от инфляции',
      description: 'Выбирайте активы, доходность которых превышает инфляцию, чтобы сохранить покупательную способность.'
    },
    {
      icon: BarChart2,
      title: 'Ребалансировка',
      description: 'Периодически восстанавливайте целевую структуру портфеля для поддержания уровня риска.'
    },
    {
      icon: Percent,
      title: 'Снижение комиссий',
      description: 'Выбирайте брокера с низкими комиссиями и предпочитайте пассивное управление активному.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по инвестированию
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Важно помнить!
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Инвестиции связаны с риском потери капитала. Прошлые результаты не гарантируют будущую доходность. Рекомендуем проконсультироваться с финансовым советником.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Узнать больше о рисках
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;